import { schemaId } from '../fixture-ids';

export const schemaLegacyAlternates = {};

export const schemaLegacyFixtures = {
  // No `version` key in legacy (current generation adds it).
  SCHEMA_CREATED: {
    action: 'SCHEMA_CREATED',
    debugData: {
      schemaId,
      name: 'Checkout Completed',
      description: 'Schema for checkout completion events',
      jsonSchema: { type: 'object', required: ['orderId'], properties: { orderId: { type: 'string' } } },
    },
  },
  SCHEMA_UPDATED: {
    action: 'SCHEMA_UPDATED',
    debugData: {
      schemaId,
      name: 'Checkout Completed',
      description: 'Schema for checkout completion events, v2 adds total',
      jsonSchema: {
        type: 'object',
        required: ['orderId', 'total'],
        properties: { orderId: { type: 'string' }, total: { type: 'number' } },
      },
      version: 2,
    },
  },
  // No `jsonSchema` key in legacy (current generation adds a latest-version lookup).
  SCHEMA_DELETED: {
    action: 'SCHEMA_DELETED',
    debugData: {
      schemaId,
      name: 'Checkout Completed',
      description: 'Schema for checkout completion events, v2 adds total',
    },
  },
};
